import { connect } from "react-redux";
import React from "react";
import ToggleButton from "react-toggle-button";

import { getAutomationDataAttr } from "../../../utils/automationUtils";

const InterestInGuardianship = (props) => {
  const { interestedInGuardianship, setInterestedInGuardianship, testId } = props;

  return (
    <>
      <div className="m-2" {...getAutomationDataAttr(testId)}>
        <ToggleButton
          activeLabel=""
          colors={{
            active: {
              base: "#5B57DC",
            },
            activeThumb: {
              base: "white",
            },
            inactive: {
              base: "#668391",
            },
            inactiveThumb: {
              base: "white",
            },
          }}
          inactiveLabel=""
          onToggle={(value) => setInterestedInGuardianship(!interestedInGuardianship)}
          thumbStyle={{ height: 25, width: 25 }}
          trackStyle={{ height: 27 }}
          value={interestedInGuardianship}
        />
      </div>
      <div className="mx-2">
        <div className="fs-16 tw:font-bold">I want to register my child for care</div>
        <div className="txt-gry fs-14">
          Register your child after creating your own account. Your dashboard will have an{" "}
          <span className="tw:font-bold">Add Child</span> button.
        </div>
      </div>
    </>
  );
};

export const GUARDIANSHIP_PROGRAM_TYPE = {
  DEFAULT: "PARENT_CHILD",
  PARENT_CHILD: "PARENT_CHILD",
};

const mapStateToProps = (state) => ({
  configs: state.configs,
});

export default connect(mapStateToProps, null)(InterestInGuardianship);
